import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "mfa-policy",
  courseId: "for-agency-admins",
  order: 4,
  title: "MFA policy",
  summary:
    "The MFA tab enforces multi-factor authentication for the department. You choose the allowed methods and set the grace period and trusted-device window.",
  learn: [
    "Turn on enforcement and pick methods",
    "Set a grace period that does not lock people out on day one",
    "Manage your own admin sign-in methods",
  ],
  minutes: 3,
  releasedAt: "2025-06-01T00:00:00.000Z",
  gate: "admin",
  body: [
    {
      type: "steps",
      items: [
        "Open the **MFA** tab (\"Security & MFA\").",
        "Turn on Enforce MFA for All Officers.",
        "Under Allowed MFA Methods, tick Authenticator App (TOTP), Device Biometrics (WebAuthn), and/or Email Code.",
        "Set the Grace Period and the Trusted Device Duration.",
        "Click **Save Settings**.",
      ],
    },
    {
      type: "paragraph",
      text: "Leave at least two methods allowed so an officer who loses a phone has another path. The Grace Period is the number of days an officer can keep signing in before enrollment is required. The Trusted Device Duration is the number of days a remembered browser skips the second factor.",
    },
    {
      type: "callout",
      tone: "warning",
      title: "Grace period of zero",
      text: "It forces enrollment at the very next login for everyone. Announce it first.",
    },
    {
      type: "callout",
      tone: "note",
      title: "Passkeys and the iOS app",
      text: "Device Biometrics (passkeys) is web only. Officers who enroll only a passkey sign in to the iOS app with a backup code, so keep Authenticator App or Email Code allowed if your officers use the phone.",
    },
    {
      type: "paragraph",
      text: "Below the settings, \"Your sign-in methods\" manages the admin account's own MFA. Session limits (12 hours maximum, 30 minutes idle) apply to every account regardless of these settings. They are CJIS requirements.",
    },
    {
      type: "paragraph",
      text: "If you also use single sign-on, read Single sign-on next to see how it interacts with this tab.",
    },
  ],
  related: ["multi-factor-authentication", "single-sign-on"],
};

export default lesson;
